import RepForm from "@/components/forms/RepForm";

export default function JoinSection() {
    return (
        <section
            id="join"
            data-testid="join-section"
            className="bg-white border-b border-slate-200 scroll-mt-24"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <p className="eyebrow">Onboarding</p>
                <h2
                    data-testid="join-headline"
                    className="font-display mt-4 text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 leading-[1.05]"
                >
                    Join the
                    <br />
                    <span className="text-slate-500">1099er Network.</span>
                </h2>
                <div className="mt-12">
                    <RepForm />
                </div>
            </div>
        </section>
    );
}
